export default "__VITE_ASSET__Bumatk$___"